import React from 'react';

function RadioButton({ onChange, option, checked, name = '' }) {
  return (
    <label className="col s6">
      <input name={name} type="radio" onChange={() => onChange(option)} checked={checked ? 'checked' : ''} />
      <span className="radio-option">{option}</span>
    </label>
  );
}

export default RadioButton;
